import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getTravauxTertiaireStub } from '../../../../config/travaux-tertiaire';

export default function TertiaireGtbPage() {
  const parcours = getTravauxTertiaireStub('gtb');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="tertiaire"
      segment="travaux"
      segmentLabel="Travaux"
      crossLinks={[
        {
          label: 'CEE BAT-* tertiaire',
          href: '/tertiaire/aides/cee-bat',
          iconName: 'sparkles',
          hint: "Prime CEE pour la fiche BAT-TH-116",
        },
        {
          label: 'Audit OPERAT',
          href: '/tertiaire/decret-tertiaire',
          iconName: 'gauge',
          hint: 'Calage de la GTB dans le plan -40 %',
        },
        {
          label: 'Prêts Bpifrance climat',
          href: '/tertiaire/aides/prets-bpifrance',
          iconName: 'banknote',
          hint: 'Financement du reste à charge GTB',
        },
      ]}
      crossLinksAllLabel="Voir toutes les aides tertiaire"
      crossLinksAllHref="/tertiaire/aides"
    />
  );
}
